module.exports = __webpack_public_path__ + "img/tiktok.2b603d81.svg";